<div class="ota-price">
    <ul class="list-unstyle p-0 m-0 all-engines">
        @for (engine of selectHotelBookingData$|async; track $index) {
            @if (engine[1].bestPrices.googleHotelAds) {
                <ng-container 
                    [ngTemplateOutlet]="li" 
                    [ngTemplateOutletContext]="{$implicit: engine[1].bestPrices.googleHotelAds, engine: engine[0]+'.googleHotelAds', price: engine[1].bestPrices.googleHotelAds.detailPrice.Ttc}"
                >
                </ng-container>
            }
            @if (engine[1].bestPrices.bestprice && engine[0]=='b') {
                <ng-container 
                    [ngTemplateOutlet]="li" 
                    [ngTemplateOutletContext]="{$implicit: engine[1].bestPrices.bestprice, engine: engine[0]+'.bestprice', price: engine[1].bestPrices.bestprice.detailPrice_without_promo.Ttc}"
                >
                </ng-container>
            }
            @if (engine[1].bestPrices.bestprice && engine[0]!='b') {
                <ng-container 
                    [ngTemplateOutlet]="li" 
                    [ngTemplateOutletContext]="{$implicit: engine[1].bestPrices.bestprice, engine: engine[0]+'.bestprice', price: engine[1].bestPrices.bestprice.detailPrice_without_promo.Ttc}"
                >
                </ng-container>
            }
            @if (engine[1].bestPrices.partner) {
                <ng-container 
                    [ngTemplateOutlet]="li" 
                    [ngTemplateOutletContext]="{$implicit: engine[1].bestPrices.partner, engine: engine[0]+'.partner', price: engine[1].bestPrices.partner.detailPrice_without_promo.Ttc}"
                >
                </ng-container>
            }
        }
    </ul>
    <button class="btn btn-snapshots snapshots-btn-2" type="button" [routerLink]="['..', 'snapshots']" queryParamsHandling="merge">
        {{'pricecheck'|translate}}
    </button>
</div>
<ng-template #li let-data let-price="price" let-engine="engine">
    <li class="item-engine b">
        @let datesAndAccupancy = selectDatesAndAccupancy$|async;
        <span>
            @switch (true) {
                @case (engine.includes('googleHotelAds')) {
                    <img src="assets/engines/asseenongoogle.svg" />
                }
                @case (engine == 'b.bestprice') {
                    <img src="assets/engines/booking.svg" />
                }
                @case (engine == 'a.bestprice') {
                    <img src="assets/engines/agoda.svg" />
                }
                @case (engine == 'bc.bestprice') {
                    <img src="assets/engines/fidelity.svg" />
                }
                @case (engine == 'bc.partner') {
                    <img src="assets/engines/connected-partner.svg" />
                }
                @case (engine == 'b.partner') {
                    <img src="assets/engines/partner.svg" />
                }
                @default {
                    <span><b>{{TRANSLATIONS[engine]|| engine|translate}}</b></span>
                }
            }
            @if (!CanAccommodateOccupancy($any(datesAndAccupancy?.adultes), $any(datesAndAccupancy?.children), data.code_occupancy, data.code_children)) {
                <span class="warning">2x</span>
            }
        </span>
        <div class="single-ota-price">
            <div class="d-flex gap-3">
                <span class="right d-flex justify-content-end">
                    <span class="price">{{price|currencyExchange:data.currency:$any(datesAndAccupancy?.currency) |async }}</span>
                </span>
                <div class="d-flex justify-content-end occupancy-info flex-grow-1">
                    <!-- <span class="divider">|</span> -->
                    <app-occupancy-info [bestPrice]="data" [datesAndAccupancy]="$any(datesAndAccupancy)"></app-occupancy-info>
                </div>
            </div>
        </div>
    </li>
</ng-template>
